export const checkDeployEnv = (env) => {
  return process.env.ENV === env;
};
